import { render, staticRenderFns } from "./Alteration.vue?vue&type=template&id=1e578d05&scoped=true&"
import script from "./Alteration.vue?vue&type=script&lang=js&"
export * from "./Alteration.vue?vue&type=script&lang=js&"
import style0 from "./Alteration.vue?vue&type=style&index=0&id=1e578d05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e578d05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e578d05')) {
      api.createRecord('1e578d05', component.options)
    } else {
      api.reload('1e578d05', component.options)
    }
    module.hot.accept("./Alteration.vue?vue&type=template&id=1e578d05&scoped=true&", function () {
      api.rerender('1e578d05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/alteration/Alteration.vue"
export default component.exports